/**
 * Tenant constants
 */

const Tenant = {
    LEMATIN: '4',
    TWENTY_MIN_DE: '6',
    TWENTY_MIN_FR: '7'
};

export {Tenant};
